module.exports = __webpack_public_path__ + "2-56.jpg?2bde6cc41513c785abadafbd8bfef189";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-56.jpg
// module id = 133
// module chunks = 0